import { FC } from 'react'
import { ReactComponent as CalendarIcon } from 'src/assets/svg/calendar.svg'
import styles from './emptyState.module.scss'

interface EmptyStateProps {
  description?: string
  icon?: 'calendar' | 'default'
  title: string
}

export const EmptyState: FC<EmptyStateProps> = ({
  title,
  description,
  icon = 'default',
}) => {
  return (
    <div className={styles.emptyState}>
      <div className={styles.iconWrapper}>
        {icon === 'calendar' && <CalendarIcon className={styles.icon} />}
      </div>
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
    </div>
  )
}
